import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import type * as React from "react";
import { cn } from "../../lib/utils";

/**
 * Podpowiedź.
 *
 * Atrybut `title` nie pojawia się przy fokusie klawiatury ani pilotem, a wygląd
 * i opóźnienie należą do systemu. Radix wiąże treść przez `aria-describedby`,
 * więc podpowiedź czyta się także bez wskaźnika.
 *
 * Podpowiedź nigdy nie nosi informacji niezbędnej do działania — na
 * telewizorze i na dotyku bywa nieosiągalna.
 */
export const TooltipProvider = TooltipPrimitive.Provider;
export const TooltipTrigger = TooltipPrimitive.Trigger;

export function Tooltip({ ...props }: React.ComponentProps<typeof TooltipPrimitive.Root>) {
  return <TooltipPrimitive.Root {...props} />;
}

export function TooltipContent({
  className,
  sideOffset = 6,
  children,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Content>) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        className={cn(
          "z-50 max-w-[16rem] rounded-md border border-border bg-popover px-2.5 py-1.5",
          "text-xs text-popover-foreground shadow-lg",
          className,
        )}
        {...props}
      >
        {children}
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  );
}
